import React, { useState } from 'react';
import {
  Route as ReactRouterRoute,
  Routes as ReactRouterRoutes
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { DFab } from '../../../dum/simple/button/d-fab';
import { SUpsertTransferDialog } from '../../../smart';
import { TransfersPage } from './transfers/transfers-page';

const routes: Route[] = [
    {
        name: 'TransfersPage',
        path: '/',
        component: <TransfersPage />,
        title: 'Administración',
        navbar: false,
    },
];

export function TransfersHomePage() {
    const [transferUpsertDialog, setTransferUpsertDialog] = useState(false);

    return (
        <DPage>
            <DFab onClick={() => setTransferUpsertDialog(true)} />
            <ReactRouterRoutes>
                {routes.map((page, index) => (
                    <ReactRouterRoute
                        key={index}
                        path={page.path}
                        element={page.component}
                    />
                ))}
            </ReactRouterRoutes>
            <SUpsertTransferDialog
                open={transferUpsertDialog}
                setOpen={setTransferUpsertDialog}
            />
        </DPage>
    );
}
